export default __webpack_public_path__ + "static/media/email.4138cd20.svg";